var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "svgcircle",
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "#212121",
    strokeOpacity: 0.87,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38184 9.83203V9.51953C7.38184 9.16146 7.44694 8.86361 7.57715 8.62598C7.70736 8.38835 7.93522 8.14258 8.26074 7.88867C8.64811 7.58268 8.89714 7.34505 9.00781 7.17578C9.12174 7.00651 9.17871 6.80469 9.17871 6.57031C9.17871 6.29688 9.08757 6.08691 8.90527 5.94043C8.72298 5.79395 8.46094 5.7207 8.11914 5.7207C7.8099 5.7207 7.52344 5.76465 7.25977 5.85254C6.99609 5.94043 6.73893 6.04622 6.48828 6.16992L6.07812 5.31055C6.73893 4.94271 7.44694 4.75879 8.20215 4.75879C8.84017 4.75879 9.34635 4.91504 9.7207 5.22754C10.0951 5.54004 10.2822 5.97135 10.2822 6.52148C10.2822 6.76562 10.2464 6.98372 10.1748 7.17578C10.1032 7.36458 9.99414 7.54525 9.84766 7.71777C9.70443 7.8903 9.4554 8.11491 9.10059 8.3916C8.79785 8.62923 8.5944 8.82617 8.49023 8.98242C8.38932 9.13867 8.33887 9.34863 8.33887 9.6123V9.83203H7.38184ZM7.18164 11.3896C7.18164 10.8981 7.4209 10.6523 7.89941 10.6523C8.13379 10.6523 8.31283 10.7174 8.43652 10.8477C8.56022 10.9746 8.62207 11.1553 8.62207 11.3896C8.62207 11.6208 8.55859 11.8047 8.43164 11.9414C8.30794 12.0749 8.13053 12.1416 7.89941 12.1416C7.66829 12.1416 7.49089 12.0765 7.36719 11.9463C7.24349 11.8128 7.18164 11.6273 7.18164 11.3896Z",
    fill: "#212121",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f4f176bd.svg";
export { ForwardRef as ReactComponent };